import React from 'react'
import './notification-template-selector.scss'
import { getClassNames } from '../../_utils/classnames'
import { INotificationBuilderState } from '../notification-builder/interfaces/notification-builder-state.interface'
import { DomainDto } from '../../dtos/domain'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { Select, Well } from '@pushly/aqe/lib/components'

type NotificationTemplateSelectProps = {
    className?: string
    builder: INotificationBuilderState
    domain: DomainDto
    value?: number
    disabled?: boolean
    onChange: (change: { id?: number; domain: DomainDto; usingTemplate?: boolean }) => void
}

export const NotificationTemplateSelector = (props: NotificationTemplateSelectProps) => {
    const { className, builder, domain, value, disabled = false, onChange } = props

    return (
        <Well
            title="Template"
            hideHeader={false}
            hideFooter={true}
            className={`notification-template-selector ${className}`}
        >
            <div>
                <div className={getClassNames('notif-template-selector')}>
                    <Select
                        prefix="Template"
                        placeholder={
                            !builder.availableTemplates.length ? (
                                <Loading3QuartersOutlined spin={true} />
                            ) : (
                                'Select a template'
                            )
                        }
                        disabled={disabled}
                        showSearch={false}
                        allowClear={true}
                        loading={builder.loading}
                        options={builder.availableTemplates.map((t) => ({ label: t.name, value: t.id }))}
                        onChange={(val) =>
                            onChange({
                                id: val as number,
                                domain,
                                usingTemplate: !!val,
                            })
                        }
                        value={value ?? undefined}
                    />
                </div>
            </div>
        </Well>
    )
}
